<div (click)="onBack()" class="overlay" [@fadeAnimation]></div>

<div class="sidepane-content">
  <div class="flex-space-between-layout template-header">
    <h1>{{ heading }}</h1>
    <hf-custom-button type="button" [class]="'square-btn btn-clear'" icon="close" iconPos="center" (onClick)="onBack()">
    </hf-custom-button>
  </div>

  <div class="template-main">
    <hf-custom-spinner *ngIf="isLoading" sidepaneLoading="true"></hf-custom-spinner>

    <form *ngIf="!isLoading" [formGroup]="form">
      <hf-custom-selector formControlName="advisor" [items]="items">
        <ng-template #itemTemplate let-item>
          <div>
            {{ item.fullName }}
          </div>
        </ng-template>
      </hf-custom-selector>
    </form>
  </div>

  <div class="template-footer">
    <hf-custom-button
      type="button"
      [disabled]="form.invalid"
      [isLoading]="isSubmitting"
      class="button-primary btn-md"
      label="Apply"
      (click)="onSubmit()"
    >
    </hf-custom-button>
    <hf-custom-button type="button" class="button-grey btn-md" label="Cancel" (click)="onBack()">
    </hf-custom-button>
  </div>
</div>
